<script setup>
import { ref, onMounted } from 'vue';
import AnnouncementsAPI from 'dashboard/api/announcements';

// One-time "what's new" pop-up. On login we fetch the latest published popup the
// user hasn't dismissed; closing it records a dismissal so it never returns.
// The HTML body is super-admin authored but still rendered in a sandboxed iframe
// (no scripts, no same-origin) as defence-in-depth.
const current = ref(null);
const show = ref(false);

onMounted(async () => {
  try {
    const { data } = await AnnouncementsAPI.active();
    if (data && data.id) {
      current.value = data;
      show.value = true;
    }
  } catch (_) {
    // best-effort — never block the dashboard on this
  }
});

const close = async () => {
  show.value = false;
  const id = current.value?.id;
  current.value = null;
  if (id) {
    try { await AnnouncementsAPI.dismiss(id); } catch (_) { /* ignore */ }
  }
};
</script>

<template>
  <div v-if="show" class="ann-overlay" @click.self="close">
    <div class="ann-modal" role="dialog" aria-modal="true">
      <button class="ann-close" type="button" aria-label="Close" @click="close">×</button>
      <h2 v-if="current?.title" class="ann-title">{{ current.title }}</h2>
      <iframe
        class="ann-frame"
        :srcdoc="current?.body_html || ''"
        sandbox
        title="Announcement"
      ></iframe>
      <div class="ann-actions">
        <button class="ann-btn" type="button" @click="close">Got it</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ann-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.ann-modal {
  position: relative;
  width: 100%;
  max-width: 560px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  padding: 22px 24px 18px;
}
.ann-close {
  position: absolute;
  top: 10px;
  right: 12px;
  border: none;
  background: none;
  font-size: 22px;
  line-height: 1;
  color: #64748b;
  cursor: pointer;
}
.ann-title {
  margin: 0 24px 12px 0;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}
.ann-frame {
  flex: 1;
  min-height: 200px;
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
}
.ann-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}
.ann-btn {
  padding: 9px 20px;
  border: none;
  border-radius: 8px;
  background: #0d9488;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
</style>
